export namespace BrowserUtils {
    export const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && 'ondeviceorientationabsolute' in window;
}
